// components/ScrollToTopButton.jsx
import React, { useState, useEffect, useRef } from 'react';
import { FaArrowUp, FaTimes } from 'react-icons/fa';
import './ScrollToTopButton.css';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasScrolledPastHero, setHasScrolledPastHero] = useState(false);
  const [showBubble, setShowBubble] = useState(false);
  const buttonRef = useRef(null);
  const bubbleRef = useRef(null);
  const timeoutRef = useRef(null);

  // Sections de navigation
  const navSections = [
    { id: 'services', label: 'Nos services' },
    { id: 'programme', label: 'Ils nous font confiance' },
    { id: 'formations', label: 'Sessions de formations' },
    { id: 'qui-est-ce-pour', label: 'Devenir formateur' },
    { id: 'conseils', label: 'Nos dernières actualités' }
  ];

  // Fonction pour vérifier si on a dépassé le Hero
  const checkScrollPosition = () => {
    const heroHeight = window.innerHeight;
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    
    setHasScrolledPastHero(scrollPosition > heroHeight);
    setIsVisible(scrollPosition > 300);
  };

  // Fonction pour remonter en haut
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setShowBubble(false);
  };

  // Fonction pour naviguer vers une section
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setShowBubble(false);
    }
  };

  // Gestion des événements de souris - VERSION SIMPLIFIÉE
  const handleMouseEnterButton = () => {
    clearTimeout(timeoutRef.current);
    // setShowBubble(true);
  };

  const handleMouseLeaveButton = () => {
    // Délai avant de cacher la bulle
    timeoutRef.current = setTimeout(() => {
      setShowBubble(false);
    }, 300); // Délai plus long pour permettre de passer à la bulle
  };

  const handleMouseEnterBubble = () => {
    clearTimeout(timeoutRef.current);
    setShowBubble(true);
  };

  const handleMouseLeaveBubble = () => {
    // Délai avant de cacher la bulle
    timeoutRef.current = setTimeout(() => {
      setShowBubble(false);
    }, 300);
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScrollPosition);
    checkScrollPosition();
    
    return () => {
      window.removeEventListener('scroll', checkScrollPosition);
      clearTimeout(timeoutRef.current);
    };
  }, []);

  // Gestion du clic en dehors de la bulle
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showBubble && 
          buttonRef.current && !buttonRef.current.contains(event.target) && 
          bubbleRef.current && !bubbleRef.current.contains(event.target)) {
        setShowBubble(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showBubble]);

  // Nettoyer le timeout quand le composant est démonté
  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  // Ne rendre le bouton que si on a dépassé le Hero
  if (!hasScrolledPastHero) return null;

  return (
    <>
      <button 
        ref={buttonRef}
        className={`scroll-to-top-btn ${isVisible ? 'visible' : ''}`}
        onClick={scrollToTop}
        onMouseEnter={handleMouseEnterButton}
        onMouseLeave={handleMouseLeaveButton}
        
        
      >
        <FaArrowUp className="arrow-icon" />
      </button>

      {/* Bulle de navigation */}
      {showBubble && (
        <div 
          ref={bubbleRef}
          className="navigation-bubble"
          onMouseEnter={handleMouseEnterBubble}
          onMouseLeave={handleMouseLeaveBubble}
        >
          <div className="bubble-header">
            <h4 className="bubble-title">Navigation rapide</h4>
            {/* <button 
              className="close-bubble"
              onClick={() => setShowBubble(false)}
              aria-label="Fermer la navigation"
            >
              <FaTimes />
            </button> */}
          </div>
          
          <div className="bubble-sections">
            {navSections.map((section) => (
              <button
                key={section.id}
                className="bubble-section-item"
                onClick={() => scrollToSection(section.id)}
                title={`Aller à: ${section.label}`}
              >
                {section.label}
              </button>
            ))}
          </div>
          
          {/* Flèche pointant vers le bouton */}
          <div className="bubble-arrow"></div>
        </div>
      )}
    </>
  );
};

export default ScrollToTopButton;